import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path fillRule="evenodd"
          d="M7.5,13 C4.467,13 2,10.533 2,7.5 C2,4.467 4.467,2 7.5,2 C10.533,2 13,4.467 13,7.5 C13,10.533 10.533,13 7.5,13 M7.5,1 C3.91,1 1,3.91 1,7.5 C1,11.09 3.91,14 7.5,14 C11.09,14 14,11.09 14,7.5 C14,3.91 11.09,1 7.5,1 M10.5,7 L8,7 L8,3.5 C8,3.224 7.776,3 7.5,3 C7.224,3 7,3.224 7,3.5 L7,7.5 C7,7.776 7.224,8 7.5,8 L10.5,8 C10.776,8 11,7.776 11,7.5 C11,7.224 10.776,7 10.5,7"/>
  </svg>
);
